import {
  FOREIGN_CA,
  INVESTOR,
  PERSONAL_TAX_USER,
  PREINCORPORATION,
} from "constants/onBoarding";
import authContext from "jwt_context&axios/authContext";
import { useContext } from "react";

export const useRoleBasedView = () => {
  const { authtoken } = useContext(authContext);

  if (!authtoken) {
    return { isPublicUser: true };
  }

  const {
    is_service_user,
    is_any_service_user,
    is_inkle_admin,
    is_foreign_ca,
    is_service_admin,
    is_super_admin,
    user_type,
    is_service_super_admin,
    is_inkle_super_admin,
    is_any_service_super_admin,
    type,
  } = authtoken;

  const isCustomer =
    !is_service_user &&
    !is_any_service_user &&
    !is_inkle_admin &&
    type !== INVESTOR;

  const isForeignCA = is_foreign_ca || user_type === FOREIGN_CA;

  const isPracticePro = is_service_user && !is_inkle_admin && !isForeignCA;

  return {
    isCpa: is_service_user,
    isAdmin: is_inkle_admin,
    isCpaInkleServiceAdmin: is_service_admin,
    isCustomer: isCustomer,
    isForeignCA: isForeignCA,
    isPublicUser: false,
    isGroupAdmin: is_super_admin,
    isPreIncorporated: user_type === PREINCORPORATION,
    isServiceSuperAdmin: is_service_super_admin,
    isInkleSuperAdmin: is_inkle_super_admin,
    isAnyServiceSuperAdmin: is_any_service_super_admin,
    isUserTypeForeignCA: isForeignCA,
    isInvestor: type === INVESTOR,
    isAnyServiceUser: is_any_service_user,
    isPracticePro: isPracticePro,
    isPersonalTaxUser: user_type === PERSONAL_TAX_USER && isCustomer,
    canManageInternalTickets: is_inkle_admin || isPracticePro,
  };
};
